import { CodeItem } from 'app/area/indicator-factors/item/types-store';

export const emptyCodeItem: CodeItem = {
    id: undefined,
    factor: undefined,
    comments: undefined,
    indicatorSubstance: undefined,
    indicatorSubstanceCategory: undefined,
    indicatorSubstanceUom: undefined,
    source: undefined,
    location: undefined,
    substance: undefined,
    substanceCategory: undefined,
    substanceUom: undefined,
    validFrom: undefined,
    unit: undefined
};
